import classes from "./PrimaryBanner.module.css";
import React, { useContext, useEffect, useState, memo } from "react";
import AuthContext from "../../store/auth-context";
import { t } from "../../locales/i18n";
import { images } from "../../assets/img";
import BookNowBtn from "../BookNowBtn";
import RemoteConfig from "../../services/RemoteConfig";
import { NAIL_SHOP_INFO } from "../../utils/Const";

const PrimaryBanner = (props) => {
  const {} = props || {};
  const { isFetchActivateRemoteConfig, selectedBranch } =
    useContext(AuthContext);
  const [banner, setBanner] = useState(images.nail7);

  // useEffect(() => {
  //   const primary_banner = RemoteConfig.getConfigValue("primary_banner");
  //   primary_banner && setBanner(primary_banner);
  // }, [isFetchActivateRemoteConfig]);

  return (
    <div className={classes.primaryBanner}>
      <div className={classes.textContainer}>
        <h2>{selectedBranch?.primaryBannerTitle}</h2>
        <h3 className={classes.textDescription}>
          {selectedBranch?.primaryBannerMsg}
        </h3>
        <BookNowBtn
          onClick={() => window.open("tel:" + NAIL_SHOP_INFO.tel, "_self")}
          style={classes.callNowBtn}
          title={"CALL NOW"}
        />
      </div>

      <div className={classes.imgContainer}>
        <img
          className={classes.primaryBannerImage}
          alt={"Primary Banner"}
          src={banner}
          loading="eager"
          decoding="async"
          fetchPriority="high"
        />
      </div>
    </div>
  );
};

export default memo(PrimaryBanner);
